import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsOfflineExporting from 'highcharts/modules/offline-exporting'
import highchartsAccessibility from 'highcharts/modules/accessibility'
import NoDataImage from '../../../common/components/NoDataImage'

HighchartsExporting(Highcharts)
HighchartsOfflineExporting(Highcharts)
highchartsAccessibility(Highcharts)

Highcharts.setOptions({
  chart: {
    style: {
      fontFamily: '"Open Sans", sansSerif',
    },
  },
})

const StackedBarChart = ({
  chartRef,
  chartType,
  chartOptions,
  chartKey = '',
  noDataImageURL,
}) => {
  const { series } = chartOptions
  const noData =
    series?.length === 0 || series?.every((item) => item?.data?.length === 0)
  return (
    <div className="tui__chart_content">
      {!noData ? (
        <figure className="highcharts-figure barchart-figure">
          <HighchartsReact
            ref={chartRef}
            key={`highcharts-${chartKey}-${JSON.stringify(chartOptions)}`}
            highcharts={Highcharts}
            options={chartOptions}
          />
        </figure>
      ) : (
        <NoDataImage imageURL={noDataImageURL} height="345px" width="100%" />
      )}
    </div>
  )
}
export default StackedBarChart
